import { ColumnSortOrder } from '~/types/Columns';

import { SortBy } from './workflowTicketTypes';

export interface SortableColumn {
  key: string;
  sortField?: string;
  [key: string]: unknown;
}

const DEFAULT_SORT_FIELD = 'ticket_last_activity_date_Ticket';

export const getSortByFromColumns = (
  columns: SortableColumn[],
  sortBy: SortBy,
): ColumnSortOrder => {
  const column = columns.find((col) => col.key === sortBy.id);
  return {
    id: column?.sortField ?? DEFAULT_SORT_FIELD,
    desc: sortBy.desc,
  };
};
